// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1vgDZ","box":"WorkspacesBox_box__2YIMX","node":"WorkspacesBox_node__2BsMq"};